<button type="button" (click)="print()" [disabled]="loading" [class]="btnClass()" data-test="printButton">
  <ng-content/>
</button>
